<template>
  <div>
    <v-dialog
      v-model="sendToStaffModal"
      persistent
      max-width="500px"
    >
      <v-card>
        <form @submit.prevent="submitForm()">
          <v-card-title class="pb-0">
            <v-flex
              xs11
              sm10
              md10
            >
              <span class="headline">
                {{ $t('orders.sendToStaffTooltip') }}
              </span>
            </v-flex>
            <v-flex
              xs1
              sm2
              md2
            >
              <v-btn
                flat
                @click="closeDialog()"
                class="close"
              >
                <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text v-if="sendToStaffModal">
            <v-layout wrap>
              <v-flex
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>{{ $t('columns.caseId') }}: </b> {{ formData.order_case_id_fk }}
              </v-flex>

              <v-flex
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>{{ $t('columns.caseOrderId') }}: </b> {{ formData.theOrderID }}
              </v-flex>

              <v-flex
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>{{ $t('columns.customer') }}: </b> {{ formData.full_name }}
              </v-flex>

              <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  autocomplete
                  :items="staffList"
                  v-model="formData.user_id_fk"
                  :error-messages="errors.collect('Staff')"
                  data-vv-name="Staff"
                  :label="$t('columns.staff') + '*'"
                  v-validate="'required'"
                  single-line
                />
              </v-flex>

              <v-flex
                xs12
                class="px-2 pb-4 mb-1"
              >
                <label class="d-block mb-1">{{ $t('columns.deadline') }}</label>
                <input
                  type="datetime-local"
                  v-model="formData.deadline"
                  class="base-date-picker"
                >
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeDialog()"
              outline
              color="normal"
            >{{ $t('common.cancel') }}</v-btn>
            <v-btn
              type="submit"
              :loading="loading"
              style="height:auto" class="submit-btn-spacing"
              outline
              color="success"
            >
              {{ $t('orders.sendTooltip') }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['sendToStaffModal', 'formData', 'staffList'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          Axios.post('api/order-case-user', this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          })
            .then(() => {
              swal({
                title: this.$t('orders.sentStatusTitle'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
              this.$emit('resetTable')
              this.closeDialog()
            })
            .catch(error => {
              swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
            })

        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orderCase/sendToStaff.vue